module.exports = __webpack_public_path__ + "img/fuwubuzhou.b985af3e.png";